import { useFeatureFlag } from 'js/sign-components/common/feature-flag';
import { defineMessages } from 'react-intl';

export function useSignAi(): boolean {
  return useFeatureFlag('HelloSign_Api_20230510_enable_open_ai_chat');
}

export const messages = defineMessages({
  close: {
    id: '',
    description: 'Close button',
    defaultMessage: 'Close chat',
  },
  aiChatBoxTooltip: {
    id: '',
    description: 'Ai chat button tooltip',
    defaultMessage: 'Sign AI chat',
  },
  english: {
    id: '',
    description: 'Ai chat button tooltip',
    defaultMessage: 'English',
  },
  japanese: {
    id: '',
    description: 'Ai chat button tooltip',
    defaultMessage: 'Japanese',
  },
  german: {
    id: '',
    description: 'Ai chat button tooltip',
    defaultMessage: 'German',
  },
  spanish: {
    id: '',
    description: 'Ai chat button tooltip',
    defaultMessage: 'Spanish',
  },
  french: {
    id: '',
    description: 'Ai chat button tooltip',
    defaultMessage: 'French',
  },
  includeSummary: {
    id: '',
    description: 'Ai chat button tooltip',
    defaultMessage: 'Include AI generated summary',
  },
  languagePlaceholder: {
    id: '',
    description: 'Select dropdown placeholder value',
    defaultMessage: 'Select a language to translate AI generated summary',
  },
  summary: {
    id: '',
    description: 'Summary tag for sign ai',
    defaultMessage: 'Summary',
  },
  documentSummaryError: {
    id: '',
    description: 'document summary error message in case of no summary available',
    defaultMessage: 'Display summary is not available. Unexpected error might have occurred or file uploaded was not PDF type.',
  },
});

export enum PageSource {
    Home = 'home',
    PrepAndSend = 'prepandsend',
    SignerApp = 'signer'
}

export enum Locales {
    DE_DE = 'de_DE',
    EN_US = 'en_US',
    ES_ES = 'es_ES',
    FR_FR = 'fr_FR',
    JA_JP = 'ja_JP',
}
